module.exports = __webpack_public_path__ + "img/expression-bad.db6ea62a.png";